import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {UIGameManager} from '../UIGameManager'
import {UIGamePlayerInformationView} from '../ui_game_players/UIGamePlayerInformationView'
import {UIGameMechanic} from '../UIGameEventController'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {TranslationObject} from '@colonist/i18n'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {robberSkinController} from '../UIGameRobberSkinController'

export class UIGamePlayerInformationRobberView implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private playerInformation: UIGamePlayerInformationView
    private robberIconView: SpriteView | undefined

    constructor(uiGameManager: UIGameManager, playerInformation: UIGamePlayerInformationView) {
        this.uiGameManager = uiGameManager
        this.playerInformation = playerInformation
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.initPlayerInformationView()
        this.initRobberIconView()

        this.resetRobberIconPlayerInformationView()
        this.robberMoved()
    }

    private initRobberIconView() {
        const bottomPlayerColor = this.uiGameManager.gameController.isPlayerSpectator ? this.uiGameManager.gameController.playOrder[0] : this.uiGameManager.gameController.myColor
        const isMyColor = this.playerInformation.player.color == bottomPlayerColor

        this.robberIconView = isMyColor ? this.getMyRobberIconView() : this.getOpponentRobberIconView()

        const robberTipTitle: TranslationObject = {key: 'strings:game.tips.robber.title'}
        const robberTipBody: TranslationObject[] = [{key: 'strings:game.tips.robber.body.0'}, {key: 'strings:game.tips.robber.body.1'}]
        this.robberIconView.setTip(robberTipTitle, robberTipBody)
    }

    private initPlayerInformationView() {
        if(!this.uiGameManager.playersController) return

        const newPlayerInformation = this.uiGameManager.playersController.playerInformationViews.find((playerInformation) => (
            playerInformation.player.color == this.playerInformation.player.color
        ))
        if(newPlayerInformation == undefined) return
        this.playerInformation = newPlayerInformation
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.RobberMoved: this.robberMoved(); break
            case UIGameEventEnums.GameStateUpdated: this.robberMoved(); break
            case UIGameEventEnums.CanvasResized: this.onCanvasResize(); break
            default: break
        }
    }

    private getMyRobberIconView(): SpriteView {
        const robberH = this.playerInformation.specialIconView.height * 0.85
        const robberTexture = UIGameSpriteHandler.getTextureFromSpritesheet(robberSkinController.getRobberSkin())
        const isUserOnPortraitMode = UIUtilsEjsVariables.isUserOnMobileAppOrWeb && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI
        const robberXPosition = isUserOnPortraitMode ? this.playerInformation.specialIconView.width - robberH : 0
        const robberYPosition = isUserOnPortraitMode ? this.playerInformation.specialIconView.height - robberH : 0

        const robberIcon = new SpriteView(robberXPosition, robberYPosition, robberH, robberH, this.playerInformation.specialIconView, robberTexture)
        return robberIcon
    }

    private getOpponentRobberIconView(): SpriteView {
        const isUserOnPortraitMode = UIUtilsEjsVariables.isUserOnMobileAppOrWeb && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI
        const robberW = isUserOnPortraitMode ? this.playerInformation.specialIconView.height * 0.9 : this.playerInformation.specialIconView.width * 0.85
        const robberTexture = UIGameSpriteHandler.getTextureFromSpritesheet(robberSkinController.getRobberSkin())
        const robberXPosition = isUserOnPortraitMode ? this.playerInformation.specialIconView.width - robberW * 1.1 : 0
        const robberYPosition = isUserOnPortraitMode ? this.playerInformation.specialIconView.height - robberW : this.playerInformation.specialIconView.height * 0.05

        const robberIcon = new SpriteView(robberXPosition, robberYPosition, robberW, robberW, this.playerInformation.specialIconView, robberTexture)
        return robberIcon
    }

    private onCanvasResize() {
        this.initPlayerInformationView()
        this.resetRobberIconPlayerInformationView()
        this.initRobberIconView()
        this.robberMoved()
    }

    private robberMoved() {
        this.resetRobberIconPlayerInformationView()

        const playerToShowRobberOn = this.uiGameManager.gameController.currentStateValidator.nextPlayerToMoveRobber
        if(this.playerInformation.player.color != playerToShowRobberOn) return

        this.initRobberIconView()
        if(this.robberIconView == undefined) return

        if(UIUtilsEjsVariables.isUserOnMobileAppOrWeb) {
            this.playerInformation.specialIconView.addChild(this.robberIconView)
            return
        }

        this.playerInformation.specialIconView.addSpriteView(this.robberIconView)
    }

    private resetRobberIconPlayerInformationView() {
        if(this.robberIconView == undefined) return
        if(this.robberIconView.parent != undefined) {
            this.playerInformation.specialIconView.removeSpriteView(this.robberIconView)
        }
        this.robberIconView.destroy()
        this.robberIconView = undefined
    }

    destroy() {
        this.resetRobberIconPlayerInformationView()
        this.uiGameManager.eventController.unregisterUIGameMechanic(this)
    }
}
